import { Card } from '@ipfabric/ui-components/Card/Card';
import { ListDivider } from '@ipfabric/ui-components/List/ListDivider/ListDivider';
import { SidePanel } from '@ipfabric/ui-components/SidePanel/SidePanel';
import type { TableColumnConfig } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { PreviewDragLayer } from 'components/PreviewDragLayer/PreviewDragLayer';
import { useTableContextSelectors } from 'components/Table/model/TableModel';
import { changeTableSettingsVisibility } from 'components/Table/model/commands/changeTableSettingsVisibility';
import { selectOrderedColumns } from 'components/Table/model/selectors/selectOrderedColumns';
import { type FC, Fragment, memo, useState } from 'react';
import {
  TABLE_SETTINGS_COLUMN_DRAG_TYPE,
  TableSettingsColumn,
  type TableSettingsColumnDragItem,
} from './TableSettingsColumn';
import { TableSettingsColumnPreview } from './TableSettingsColumnPreview';

const BareTableSettings: FC = () => {
  const ctxProps = useTableContextSelectors({
    columns: prop('columns'),
    columnVisibility: prop('settings', 'columnVisibility'),
    dispatch: prop('dispatch'),
    openSettings: prop('openSettings'),
    orderedColumns: selectOrderedColumns,
  });
  const [columnIsDragged, setColumnIsDragged] = useState<
    TableColumnConfig['key'] | null
  >(null);

  const closeSettings = () => {
    ctxProps.dispatch(changeTableSettingsVisibility, {
      value: false,
    });
  };

  if (!ctxProps.openSettings) {
    return null;
  }

  return (
    <SidePanel
      closeOnBackdropClick
      title='Display settings'
      onClose={closeSettings}
      closeButtonTestId='table-settings-close'
    >
      <Card>
        <PreviewDragLayer<TableSettingsColumnDragItem>
          itemType={TABLE_SETTINGS_COLUMN_DRAG_TYPE}
        >
          {(item) => (
            <TableSettingsColumnPreview
              draggedColumn={columnIsDragged}
              item={item}
            />
          )}
        </PreviewDragLayer>
        <h3 className='pt px m-0 text-level-5 font-semibold'>
          {'Column Visibility & Order'}
        </h3>
        <span className='px py-sm block'>
          {'Drag & Drop Column to change order'}
        </span>
        <div className='flex flex-col pb-sm'>
          {ctxProps.orderedColumns?.map((orderedColumn, index) => (
            <Fragment key={orderedColumn.key}>
              {index !== 0 ? <ListDivider padded /> : null}
              <TableSettingsColumn
                columnIndex={index}
                columnIsDragged={false}
                column={orderedColumn}
                onColumnIsDraggedChange={setColumnIsDragged}
              />
            </Fragment>
          ))}
        </div>
      </Card>
    </SidePanel>
  );
};

export const TableSettings = memo(BareTableSettings);
